/**
 * ENG-3625: whether this browser is one where Firebase loaded its popup sign-in iframe before the first
 * auth state, back when auth was initialized with the popup resolver. These are the browsers that block
 * a popup opened after a network wait, so on them the sign-in buttons wait for the iframe.
 *
 * A copy of `BrowserPopupRedirectResolver._shouldInitProactively` in @firebase/auth 1.10.8
 * (dist/esm2017/index-*.js): `_isMobileBrowser() || _isSafari() || _isIOS()`, with those three
 * functions copied below. `@firebase/auth/internal` does not export them. lib/popupResolverProactive.test.ts
 * checks this against the SDK's own getter, so an SDK upgrade that changes it fails there.
 */
export function initsPopupResolverProactively(userAgent: string = typeof navigator === "undefined" ? "" : navigator.userAgent): boolean {
  const ua = userAgent || "";
  return isMobileBrowser(ua) || isSafari(ua) || isIOS(ua);
}

/** `_isIOS`. iPadOS reports a Mac, so a Mac that says Mobile counts. */
function isIOS(ua: string): boolean {
  return /iphone|ipad|ipod/i.test(ua) || (/macintosh/i.test(ua) && /mobile/i.test(ua));
}

/** `_isSafari`: Safari's token without Chrome's, Chrome for iOS's or Android's. */
function isSafari(ua: string): boolean {
  const lower = ua.toLowerCase();
  return lower.includes("safari/") && !lower.includes("chrome/") && !lower.includes("crios/") && !lower.includes("android");
}

/** `_isMobileBrowser`: iOS, Android, webOS, BlackBerry, Windows Phone or IE Mobile. */
function isMobileBrowser(ua: string): boolean {
  return isIOS(ua) || /android/i.test(ua) || /webos/i.test(ua) || /blackberry/i.test(ua) || /windows phone/i.test(ua) || /iemobile/i.test(ua);
}
